
import axios from 'axios';

import { showAlert } from './alerts';


export const currentFeedback = async (feedback) => {


	try {

		const result = await axios({

			method: 'POST',
			url: `/api/v1/feedback/current-feedback`,
			data: {
				// name,
				// email,
				feedback
			}
		})


		if (result.data.status === 'success') {

			showAlert('success', 'Feedback Submitted Successfully!!');


			window.setTimeout(() => {

				location.assign(`/`)

			}, 1500)

		}

	} catch (err) {

		console.log(err);
	}

}